/** Faq (#faq) — native <details> accordion; the same Q&A feeds FAQPage JSON-LD. */

import { useT } from '@/i18n';
import { SectionHeading } from './shared';

export const FAQ_KEYS = [1, 2, 3, 4, 5, 6, 7] as const;

export function Faq() {
  const { t } = useT();
  return (
    <section id="faq" className="mx-auto w-full max-w-3xl px-4 py-16 sm:px-6 sm:py-20 lg:px-8 lg:py-24">
      <SectionHeading eyebrow={t('routes.landing.v2.faq.eyebrow')} title={t('routes.landing.v2.faq.title')} />
      <div className="mt-10 space-y-3">
        {FAQ_KEYS.map((n) => (
          <details
            key={n}
            data-testid={`faq-item-${n}`}
            className="group rounded-token-lg border border-border bg-surface px-5 py-4 shadow-elevation-1 open:shadow-elevation-2"
          >
            <summary className="flex cursor-pointer list-none items-center justify-between gap-4 font-semibold text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring">
              {t(`routes.landing.v2.faq.q${n}`)}
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" className="h-5 w-5 shrink-0 transition-transform group-open:rotate-180 motion-reduce:transition-none">
                <path d="m19.5 8.25-7.5 7.5-7.5-7.5" />
              </svg>
            </summary>
            <p className="mt-3 leading-relaxed text-muted">{t(`routes.landing.v2.faq.a${n}`)}</p>
          </details>
        ))}
      </div>
    </section>
  );
}
